/**
 * Dependencies.
 */
import OrderRequestModel from '@/api/order-request/order-request.model';
import { ResultModel } from '@/api/result/result.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class OrderRequestService extends BaseService<OrderRequestModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      OrderRequestModel,
      OrderRequestModel.name,
      applicationConstant.apiCustomerPrivateUrl
    );
  }

  /**
   * Cancel.
   */
  cancel(id: number): Promise<ResultModel> {
    const endpoint = `${this.getModelEndpoint}/${id}/cancel`;

    return this.POST(endpoint, {});
  }

  /**
   * Set message read.
   */
  setMessageRead(id: number): Promise<ResultModel> {
    const endpoint = `${this.getModelEndpoint}/${id}/setMessageRead`;

    return this.POST(endpoint, {});
  }

  /**
   * Validate user.
   */
  validateUser(key: string): Promise<ResultModel> {
    const endpoint = `${this.getModelEndpoint}/order/${key}/validateUser`;

    return this.GET(endpoint);
  }
}

/**
 * Export `orderRequestService`.
 */
export const orderRequestService = new OrderRequestService();
